// Campus photo for /colleges/university-of-rhode-island: CC BY-SA 4.0, by Kenneth C. Zirkel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AURI_East_Hall_and_Washburn_Hall.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-rhode-island/; credited under the photo.
const photo = {
    "slug": "university-of-rhode-island",
    "alt": "East Hall and Washburn Hall, granite buildings beside a lawn at the University of Rhode Island in Kingston",
    "src": "/colleges/university-of-rhode-island/campus-1600.webp",
    "srcSmall": "/colleges/university-of-rhode-island/campus-800.webp",
    "srcMid": "/colleges/university-of-rhode-island/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-rhode-island/og.jpg",
    "title": "URI East Hall and Washburn Hall",
    "author": "Kenneth C. Zirkel",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AURI_East_Hall_and_Washburn_Hall.jpg",
    "read": "2026-10-01"
};

export default photo;
